import { CSSProperties } from 'react';
import styled from '@mui/styled-engine';
import Slider from '@mui/material/Slider';

const PrettoSlider = styled(Slider)({
  color: 'var(--color)',
  height: 8,
  '& .MuiSlider-track': {
    border: 'none',
  },
  '& .MuiSlider-thumb': {
    height: 24,
    width: 24,
    backgroundColor: '#fff',
    border: '2px solid currentColor',
    '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
      boxShadow: 'inherit',
    },
    '&::before': {
      display: 'none',
    },
  },
  '& .MuiSlider-valueLabel': {
    lineHeight: 1.2,
    fontSize: 12,
    background: 'unset',
    padding: 0,
    width: 32,
    height: 32,
    borderRadius: '50% 50% 50% 0',
    backgroundColor: '#52af77',
    transformOrigin: 'bottom left',
    transform: 'translate(50%, -100%) rotate(-45deg) scale(0)',
    '&::before': { display: 'none' },
    '&.MuiSlider-valueLabelOpen': {
      transform: 'translate(50%, -100%) rotate(-45deg) scale(1)',
    },
    '& > *': {
      transform: 'rotate(45deg)',
    },
  },
});

export const themeColors = {
  '00000001': { '--color': '#DC0028', '--color-white': '#FFD6D8' } as CSSProperties, // S. Bilbao
  '00000002': { '--color': '#DC0028', '--color-white': '#FFD6D8' } as CSSProperties, // Occident
  '00000006': { '--color': '#E2001A', '--color-white': '#f9ccd1' } as CSSProperties, // GES
  '00000007': { '--color': '#141476', '--color-white': '#d0d0e4' } as CSSProperties, // U. Alcoyana
  '00000010': { '--color': '#003082', '--color-white': '#ccd6e6' } as CSSProperties, // MGS
  '00000011': { '--color': '#000D6E', '--color-white': '#E1D9FF' } as CSSProperties, // Helvetia
  '00000016': { '--color': '#0094D9', '--color-white': '#CCEAF7' } as CSSProperties, // Asitur
  '00000020': { '--color': '#DC0028', '--color-white': '#FFD6D8' } as CSSProperties, // PlusUltra
  '00000025': { '--color': '#004B9B', '--color-white': '#ccdbeb' } as CSSProperties, // Reale
  '00000045': { '--color': '#004B9B', '--color-white': '#ccdbeb' } as CSSProperties, // Fiatc
  '00000060': { '--color': '#5BD1D7', '--color-white': '#def6f7' } as CSSProperties, // Caser
};

export default PrettoSlider;
